import React, { useEffect, useState } from 'react';
import { func, object } from 'prop-types';

import Dropdown from 'library/components/form-components/dropdown2';
import { QuestionBody } from 'apps/journey/components/user-profile-setup/components/user-profile-setup-modal/components/styled-question';
import { resolve } from 'library/helpers/path-resolver';

const DropdownSelection = ({ answer, question, handleChange }) => {
  const [activeOption, setActiveOption] = useState();

  useEffect(() => {
    let defaultValue = resolve(answer, 'dropdown_selection', '');
    let value;
    if (defaultValue) {
      value = question?.answer_choices?.find((opt) => opt.key === defaultValue);
    }
    setActiveOption(resolve(value, 'key', ''));
  }, [question.id]);

  const formatOptions = () =>
    question?.answer_choices?.map((option) => ({
      label: option.value,
      value: option.key,
    }));

  return (
    <QuestionBody question={question}>
      <Dropdown
        label=""
        ariaLabel={question.text}
        placeholder="Make a selection"
        name="dropdown_selection"
        onChange={handleChange}
        options={formatOptions()}
        required
        value={activeOption}
        key={question.id}
      />
    </QuestionBody>
  );
};

DropdownSelection.propTypes = {
  answer: object,
  question: object,
  handleChange: func,
};

export default DropdownSelection;
